// project imports
import AuthGuard from 'utils/route-guard/AuthGuard';
import MainLayout from 'layout/MainLayout';
import SamplePage from 'views/sample-page';
import DashboardAnalytics from 'views/dashboard/Analytics';
import StateMachinesList from 'views/application/stateMachines/StateMachinesList';
import StateMachinesExecutionsList from 'views/application/stateMachines/StateMachinesExecutionsList';
import StateMachineExecutionHistory from 'views/application/stateMachines/StateMachineExecutionHistory';
import LogsPage from 'views/application/loggerPage';
import LogsHistory from 'views/application/loggerPage/LogsHistory';

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/process/inventory',
            element: <SamplePage process="INVENTORY" />
        },
        {
            path: '/process/prices',
            element: <SamplePage process="PRICES" />
        },
        {
            path: '/search/:slug',
            element: <SamplePage process="" />
        },
        {
            path: '/dashboard/analytics',
            element: <DashboardAnalytics />
        },
        {
            path: '/stateMachines',
            element: <StateMachinesList />
        },
        {
            path: '/stateMachines/:stateMachineId',
            element: <StateMachinesExecutionsList />
        },
        {
            path: '/stateMachines/:stateMachineId/:stateMachineExecutionId',
            element: <StateMachineExecutionHistory />
        },
        {
            path: '/',
            element: <DashboardAnalytics />
        },
        // LOGS
        {
            path: '/history',
            element: <LogsPage />
        },
        {
            path: '/history/:logType',
            element: <LogsHistory />
        }
    ]
};

export default MainRoutes;
